import React from 'react';
import { useNavigate } from 'react-router-dom';
import Item from '@component/gridgio/project/item';
import PageTemplate from '@page/gridgio/page-template';
import { GRIDGIO_PATH } from '@constant/gridgio/route-path';
import * as color from '@constant/color';

const ItemPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <PageTemplate
      customHeader='none'
      title='프로젝트'
      mode='back'
      backgroundColor={color.GRAY_BACKGROUND_COLOR}
      handleNavigationClick={() => navigate(GRIDGIO_PATH.PROJECT_HOME_PATH)}>
      <Item />
    </PageTemplate>
  );
};
export default ItemPage;
